// extracted by mini-css-extract-plugin
export default {"cls1":"Reader-cls1_ysm","cls2":"Reader-cls2_UVq Reader-cls1_ysm"};